import { createSlice } from '@reduxjs/toolkit';
import { baseOnboardingUrl } from './hooks';

const initialState = {
  // Modal-specific state
  baseUrl: baseOnboardingUrl,
  // Stage checklist data
  stageCheckList: {
    "orderPhones": {
      "workflows": ["voip", "dso"],
      "description": "order the phones from teledynamics"
    },
    "repovisionPhones": {
      "workflows": ["voip", "dso"],
      "description": "retrieve information of phones that will be re-provisioned"
    },
    "releasePhones": {
      "workflows": ["voip", "dso"],
      "description": "release any phones on Yealink that will be re-provisioned"
    },
    "voipConfig": {
      "workflows": ["voip", "dso"],
      "description": "configure the yealink group, vodiaDomain, and sip settings"
    },
    "vodia-registration-qr-code": {
      "workflows": ["voip", "dso"],
      "description": "verify the vodia registration QR code BEFORE proceeding with config, provisioning, and testing"
    },
    "vodiaDomain": {
      "workflows": ["voip", "dso"],
      "description": "vodiaDomain is set in db"
    },
    "phoneMaps": {
      "workflows": ["non-voip", "dso"],
      "description": "phoneMaps in db"
    },
    "timezone-db": {
      "workflows": ["non-voip", "dso"],
      "description": "timezone is set in db"
    },
    "timezone-vodia": {
      "workflows": ["non-voip", "dso"],
      "description": "timezone is set in vodia"
    },
    "cdrUrl": {
      "workflows": ["voip", "dso"],
      "description": "vodia tenant has CDR url: 'jsons://dentalexpressserver.azurewebsites.net/webhooks/vodia/cdr' "
    },
    "callRecordingSettings": {
      "workflows": ["non-voip", "dso"],
      "description": "call recording settings are set in vodia"
    },
    "wireless-lines": {
      "workflows": ["non-voip", "dso"],
      "description": "wireless lines are set in yealink portal"
    },
    "retell-number": {
      "workflows": ["non-voip", "dso"],
      "description": "retell number is set in db"
    },
    "openProvisionWindow": {
      "workflows": ["voip", "dso"],
      "description": "if configuring the vodia domain and extensions in advance, make sure the provisioning window is open"
    },
    "testCall": {
      "workflows": ["voip", "dso"],
      "description": "test the call from the new phones. both inbound and outbound (test number used for ANI)"
    },
    "reset-ani": {
      "workflows": ["non-voip", "dso"],
      "description": "reset the ANI after the test call"
    }
  },
  
  // Loading and error states
  loading: false,
  error: null,
  
  // Success state
  success: false
};

const phonesSlice = createSlice({
  name: 'phones',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const {
  clearError,
  clearSuccess,
  setLoading
} = phonesSlice.actions;

// Selectors
export const selectBaseUrl = (state) => state.phones.baseUrl;
export const selectStageCheckList = (state) => state.phones.stageCheckList;
export const selectLoading = (state) => state.phones.loading;
export const selectError = (state) => state.phones.error;
export const selectSuccess = (state) => state.phones.success;

export default phonesSlice.reducer;
